import React, {Component} from 'react';
import ImageList from "../components/ImageList";

import image_1 from '../../resources/images/history/history_image1.jpg';
import image_2 from '../../resources/images/history/history_image2.jpg';
import image_3 from '../../resources/images/history/history_image3.jpg';
import image_4 from '../../resources/images/history/history_image4.jpg';
import image_5 from '../../resources/images/history/history_image5.jpg';
import image_6 from '../../resources/images/history/history_image6.jpg';


const images = [
    {
        img: image_1,
        title: "AA",
        author: "BB",
        cols: 2,
    },
    {
        img: image_5,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: image_3,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: image_4,
        title: "AA",
        author: "BB",
        cols: 2
    },
    {
        img: image_2,
        cols: 2
    },
    {
        img: image_6,
        cols: 2
    }
];

class History extends Component {

    render() {
        return (
            <div className={"info-split-wrap"}>
                <div className={"half_width left_half"}>
                    <p className={"info_text"}>
                        After several years of travelling the world, searching for a perfect spot to buy and renovate I
                        took a 2 week holiday to Morocco. This is when I discovered Essaouira. After spending the time
                        walking the delightful medina streets, soaking up the atmosphere of the fishing port and
                        enjoying the fantastic regional cuisine in the many local restaurants, I decided this was the
                        place I could settle and build the home of my dreams. </p>
                    <p className={"info_text"}>
                        It took 4-5 months but eventually I found an ideal site located within the walls in a quiet
                        traditional part of the medina. After 15 months of renovation - a lot of hard work and laughter
                        - it finally took shape to be the Riad that we know and love today and is named after my
                        daughter Remmy. </p>
                    <p className={"info_text"}>
                        After living in Morocco on and off over the past 10 years, I have travelled around many cities
                        and regions and would be able to advise you on places you may wish to visit on your trip.
                    </p>
                </div>
                <div className={"half_width right_half"}>
                    <ImageList images={images}/>
                </div>
            </div>
        );
    }
}

export default History
